import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ReduxControls } from "rhombus-react";
import { Field } from "redux-form";

import "./EditableInput.css";

export default function EditableInput({ dependentValues = {} }) {
	const { id, rowIndex, disabled = false, hasError = false, placeholder } = dependentValues;
	const fieldIndex = Number.isInteger(rowIndex) ? rowIndex : id - 1;
	const containerClassName = classNames("editable-input-container", { "has-error": hasError });

	return (
		<div className={containerClassName}>
			<Field
				component={ReduxControls.Input}
				name={`${fieldIndex}.name`}
				disabled={disabled}
				placeholder={placeholder}
				className="grid-editable-input"
				onKeyDown={e => e.stopPropagation() } // Prevent the DataGrid from intercepting keyboard events
			/>
		</div>
	);
}

EditableInput.displayName = "EditableInput";

EditableInput.propTypes = {
	dependentValues: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		rowIndex: PropTypes.number,
		disabled: PropTypes.bool,
		hasError: PropTypes.bool,
		placeholder: PropTypes.string,
	}),
};
